import { Navigate, Outlet } from "react-router-dom";
import { RootState } from "configs/configureStore";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { checkSession } from "redux/auth/slice";
import { LOGIN } from "./route.constant";

const PrivateRoutes = () => {
  const dispatch = useDispatch();
  const { isLoggedIn } = useSelector((state: RootState) => state.authSlice);

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(checkSession());
    }
  }, [dispatch, isLoggedIn]);

  if (!isLoggedIn) return <Navigate to={LOGIN} replace />;

  return <Outlet />;
};

export default PrivateRoutes;
